import React from 'react';

export default function ProxyInput({ value, onChange, disabled }) {
  const lineCount = value.split('\n').filter((l) => l.trim()).length;
  return (
    <div className="bg-white border border-orange-100 rounded-2xl p-5 shadow-sm flex flex-col">
      <div className="flex justify-between items-center mb-3">
        <h3 className="text-slate-700 font-bold flex items-center gap-2 text-sm">
          <span className="text-base">📋</span> Proxy List
        </h3>
        <span className="text-xs font-bold px-2.5 py-1 rounded-full bg-orange-50 text-orange-400 border border-orange-200">
          {lineCount} loaded
        </span>
      </div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={"Paste proxies here...\n192.168.1.1:8080\nuser:pass@10.0.0.1:1080"}
        className="w-full bg-orange-50/50 border border-orange-100 rounded-xl p-3 text-sm text-slate-600 font-mono focus:outline-none focus:border-orange-300 focus:ring-2 focus:ring-orange-100 resize-none transition-all disabled:opacity-50 placeholder-slate-300"
        style={{ minHeight: '140px', height: '140px' }}
        spellCheck="false"
      />
    </div>
  );
}